module.exports = __webpack_public_path__ + "img/undang-teman.531461d1.svg";